import script from "./CompetitionsEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./CompetitionsEdit.vue?vue&type=script&setup=true&lang=js"

import "./CompetitionsEdit.vue?vue&type=style&index=0&id=87c56fc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87c56fc6"]])

export default __exports__